import { useState, useEffect } from 'react';

/**
 * A custom hook that returns a debounced version of the input value.
 *
 * @param value - The input value to debounce.
 * @param milliSeconds - The amount of time to wait before updating the debounced value.
 * @returns The debounced value.
 */
export const useDebounce = (value: string, milliSeconds: number) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, milliSeconds);

    return () => {
      clearTimeout(handler);
    };
  }, [value, milliSeconds]);

  return debouncedValue;
};
